import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';
import { AgencyMsaRate } from '../types/AgencyMsaRate';

const AGENCY_MSA_RATES_URL = '/v2/admin/agency-msa-rates';
const UPLOAD_URL = '/upload';

class AgencyMsaRateAdminService {

  static findByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<AgencyMsaRate>> {
    return axios.get(AGENCY_MSA_RATES_URL, config);
  }

  static upload(file: FormData, config?: AxiosRequestConfig): Promise<DataResponse<AgencyMsaRate>> {
    return axios.post(AGENCY_MSA_RATES_URL + UPLOAD_URL, file, config);
  }

  static create(data: AgencyMsaRate, config?: AxiosRequestConfig): Promise<DataResponse<AgencyMsaRate>> {
    return axios.post(AGENCY_MSA_RATES_URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${AGENCY_MSA_RATES_URL}/${id}`, config);
  }
}

export { AgencyMsaRateAdminService };
